import { useSelector } from 'react-redux';
import {
    getAutoGainControl,
    getSelectedMicrophone,
    selectSelectedPhoneNumber
} from "../../../store/features/calls/dialerSlice";
import { useAppDispatch } from "../../../store/store";
import {createDefaultEventHandlers} from "../services/sipService.ts";
import {buildAudioConstraints} from "./audioConstraints";


export const useCallOptions = () => {
    const dispatch = useAppDispatch();
    const selectedPhoneNumber = useSelector(selectSelectedPhoneNumber);
    const selectedMicrophone = useSelector(getSelectedMicrophone);
    const autoGainControl = useSelector(getAutoGainControl);

    const mediaConstraints = {
        audio: buildAudioConstraints(selectedMicrophone, autoGainControl),
        video: false
    };

    const eventHandlers = createDefaultEventHandlers(dispatch);

    const options = {
        ...(selectedPhoneNumber ? { fromUserName: selectedPhoneNumber.msisdn?.toString() } : {}),
        eventHandlers,
        mediaConstraints,
        pcConfig: {
            "iceServers": [
                {
                    "urls": [
                        "stun:stun.cloudflare.com:3478"
                    ]
                }
            ]
        },
        sdpTransform: (sdp: string): string => {
            // NOTE: JsSIP 3.10.1 ignores this option (the supported hook
            // is the 'sdp' event, wired in sipService.installSdpMangling).
            // Kept for parity in case JsSIP behaviour changes / for unit
            // testing the transform in isolation.
            if (!/a=maxptime:20/.test(sdp)) {
                sdp = sdp.replace(/a=rtpmap:\d+ opus\/48000\/2\r\n/, (match: string) => {
                    return match + "a=maxptime:20\r\n";
                });
            }
            if (!/a=ptime:20/.test(sdp)) {
                sdp = sdp.replace(/a=rtpmap:\d+ opus\/48000\/2\r\n/, (match: string) => {
                    return match + "a=ptime:20\r\n";
                });
            }
            return sdp;
        }
    };

    return options;
};